import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

export function LoginPage() {
  const { requestMagicLink, loginGuest } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleMagic = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await requestMagicLink(email);
      setSent(true);
    } catch {
      setError('Envoi impossible');
    }
  };

  const handleGoogle = () => {
    window.location.href = '/api/auth/google';
  };

  const handleGuest = async () => {
    await loginGuest();
    navigate('/play');
  };

  return (
    <main className="page login">
      <h1>Connexion</h1>
      {sent ? (
        <p>Lien envoyé — vérifie ta boîte mail.</p>
      ) : (
        <form onSubmit={handleMagic}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="toi@exemple.fr"
          />
          <button type="submit" className="btn primary">{t('auth.magicLink')}</button>
        </form>
      )}
      {error && <p className="error">{error}</p>}
      <button type="button" className="btn secondary" onClick={handleGoogle}>
        {t('auth.google')}
      </button>
      <button type="button" className="btn ghost" onClick={handleGuest}>
        {t('landing.ctaGuest')}
      </button>
      <Link to="/">Retour</Link>
    </main>
  );
}
